import * as yup from 'yup';

export default yup.object().shape({
  chatType: yup.string().required('Chat type is required'),
  chatVariant: yup.string().required('Chat variant is required'),
  chatPlatform: yup.string().required('Platform is required'),
  iotDevice: yup.object().required('IoT Device is required'),
});
